module.exports = __webpack_public_path__ + "img/login.ef371952.svg";